import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Loader, TabsPanel } from 'ui';
import { EntitiesTable } from 'modules/common';
import { useFilterOptions } from 'modules/ESG/services/esgLendingService';
import { ratingTypes } from 'shared/constants/ratingTypes';
import { getEsgCoverageAction } from 'store/esgCoverage/esgCoverageActions';

const ESGCoverage = () => {
  const { t } = useTranslation();
  const { query } = useParams();

  const esgCoverageData = useSelector(({ esgCoverage }) => esgCoverage);

  const regs = useFilterOptions();

  const isIndustrySearch = query.includes('i-');

  const esgContractData = useSelector(({ esgContract }) => esgContract);

  const filteredIndustry = regs.data?.industries
    .filter((val) => `i-${val.industryCode}` === query)
    .map(({ industryCode, industryName }) => ({
      code: industryCode,
      name: industryName,
      industryCode,
      industryName,
    }))[0];

  const filteredRegions = regs.data?.continents
    .filter((item) => item.continentCode.includes(query))
    .flatMap((item) =>
      item.countries.map((country) => ({
        name: country.countryName,
        iso: country.countryCode,
        continent: item.continentName,
        continentCode: query,
      })),
    );

  if (regs.loading || esgContractData.isPending) {
    return <Loader center />;
  }

  const initialFilter = isIndustrySearch
    ? {
        industries: [filteredIndustry.name],
      }
    : {
        countries: filteredRegions.map((value) => value.iso),
        validated: true,
      };

  const initialFilterModalValues = isIndustrySearch
    ? {
        industries: [filteredIndustry],
      }
    : { countries: filteredRegions };

  return (
    <>
      <Box mb={2}>
        <Typography variant="h5">{t('ESG coverage')}</Typography>
      </Box>
      <TabsPanel active="esgCoverageData">
        <div label={t('Entities')} value="esgCoverageData" counter={esgCoverageData?.total || 0}>
          <EntitiesTable
            dataSelector={esgCoverageData}
            actionCreator={getEsgCoverageAction(regs)}
            constantFilter={{ withRatingOnly: true }}
            ratingType={ratingTypes.ESG_IMPACT}
            initialFilter={initialFilter}
            initialFilterModalValues={initialFilterModalValues}
          />
        </div>
      </TabsPanel>
    </>
  );
};

export { ESGCoverage };
